import { useEffect } from 'react'
import { useMapboxMapContext } from '../contexts/MapboxMapContext'

export interface UseTimelineRoutePreviewProps {
  snappedGeometry?: GeoJSON.LineString | null
  isDrawMode: boolean
}

/**
 * Hook for managing timeline route preview layer
 * Shows preview of route when building from timeline (not draw mode)
 */
export function useTimelineRoutePreview({
  snappedGeometry,
  isDrawMode
}: UseTimelineRoutePreviewProps) {
  const { map, isLoaded, styleLoaded } = useMapboxMapContext()

  useEffect(() => {
    if (!map.current || !isLoaded || !styleLoaded) return

    if (!map.current.isStyleLoaded()) {
      map.current.once('styledata', () => {})
      return
    }

    try {
      if (snappedGeometry && !isDrawMode) {
        if (!map.current.getSource('timeline-route-preview')) {
          map.current.addSource('timeline-route-preview', {
            type: 'geojson',
            data: snappedGeometry
          })
        } else {
          (map.current.getSource('timeline-route-preview') as mapboxgl.GeoJSONSource).setData(snappedGeometry)
        }

        if (!map.current.getLayer('timeline-route-preview')) {
          map.current.addLayer({
            id: 'timeline-route-preview',
            type: 'line',
            source: 'timeline-route-preview',
            layout: {
              'line-join': 'round',
              'line-cap': 'round'
            },
            paint: {
              'line-color': '#3b82f6',
              'line-width': 5,
              'line-opacity': 0.8
            }
          })
          if (map.current.getLayer('route-lines')) {
            map.current.moveLayer('timeline-route-preview', 'route-lines')
          }
          if (map.current.getLayer('waypoint-markers')) {
            map.current.moveLayer('timeline-route-preview', 'waypoint-markers')
          }
        }
      } else {
        if (map.current.isStyleLoaded()) {
          if (map.current.getLayer('timeline-route-preview')) {
            map.current.removeLayer('timeline-route-preview')
          }
          if (map.current.getSource('timeline-route-preview')) {
            map.current.removeSource('timeline-route-preview')
          }
        }
      }
    } catch (error) {
      if (map.current?.isStyleLoaded()) {
      }
    }
  }, [map, isLoaded, styleLoaded, snappedGeometry, isDrawMode])
}

